export default __webpack_public_path__ + "static/media/interior-accept.1f210725.png";